<template>
    <div class="recharge spackage padding-20 bgc box-shadow">



        <div v-if="type == 1">
            <div class="status-icon">
                <i class="el-icon-success"></i>
            </div>
            <p class="name">充值成功</p>
            <div class="info-card">
                <p><span class="right">充值金额:</span><span>{{data.ordermoney}}元</span></p>
                <p><span class="right">账户余额:</span><span>{{data.allbalance}}元</span></p>
                <p><span class="right">充值时间:</span><span>{{data.ordertime}}</span></p>
            </div>
        </div>


        <div v-if="type == 2">
            <div class="status-icon">
                <i class="el-icon-error"></i>
            </div>
            <p class="name">充值失败</p>
        </div>

        <el-button type="primary" @click="goto">返回营销中心</el-button>

    </div>
</template>

<script>
    import {queryorderpayresult} from '@/api/marketingCenterApi'
    import {getCookie} from '@/common/js/tools';    // 引入 tools 库
    import Loading from 'base/loading/loading';    // 引入 loading 组件
    import {mapActions} from 'vuex';       // 引入 vuex 组件
    import $ from 'jquery';       // 引入 jquery 组件
    export default {
        name: "Recharge",
        data() {
            return {
                type: 0,
                token: JSON.parse(sessionStorage['user']).loginToken, // token
                shopID: JSON.parse(sessionStorage['shop']).ShopID, // 店铺id
                sessionUser: JSON.parse(sessionStorage['user']),
                orderid: this.$route.query.orderid,
                rid: this.$route.query.rid,
                result: this.$route.query.result,
                sign: this.$route.query.sign,
                data: {}
            }
        },
        mounted(){
            var dataapi = {
                LoginToken: this.token,
                ShopID: this.shopID,
                orderid: this.orderid,
                rid:  this.rid,
                result:  this.result,
                sign:  this.sign,
            }
            this.setLoading(true)
            queryorderpayresult({
                data: dataapi,
                success: data => {
                    this.setLoading(false)
                    console.log(data)
                    if(data.code === '000') {
                        this.type = 1
                        this.data = data.data
                    }
                },
                error: data => {
                    this.setLoading(false)
                    console.log(data)
                    if(data.code === '301') {
                        this.type = 2
                    }
                }
            })
        },
        methods: {
            goto(){
                this.$router.push('/marketingCenter/marketingCenter')
            },
            ...mapActions (['setLoading'])
        }
    }
</script>

<style lang="scss">
    .recharge {
        min-height: 500px;
        .el-button {
            display: block;
            margin: auto;
            margin-top: 40px;
        }
        p {
            text-align: center;
        }
        .status-icon {
            margin: 45px auto 20px auto;
            width: 71px;
            height: 71px;
            font-size: 71px;
        }
        .el-icon-error {
            color: #F56C6C;
        }
        .el-icon-success {
            color: #67C23A;
        }
        p.name {
            font-size: 24px;
            font-weight: 500;
        }
        .info-card {
            display: block;
            margin: auto;
            margin-top: 30px;
            padding-top: 30px;
            width: 514px;
            height: 140px;
            border: solid 1px #eee;
            box-sizing: border-box;
            p {
                margin-bottom: 15px;
                overflow: hidden;
                text-align: left;
                span {
                    float: left;
                    width: 50%;
                    font-size: 16px;
                    color: #303133;
                }
                .right {
                    padding-right: 40px;
                    text-align: right;
                    box-sizing: border-box;
                }
            }
            .headerimg {
                .right {
                    line-height: 50px;
                }
            }
        }
        img {
            display: inline-block;
            width: 50px;
            height: 50px;
            border-radius: 50px;
        }
    }
</style>
